import { z } from 'zod'
import { oc } from '@orpc/contract'
import { eventIterator } from '@orpc/contract'
import { generateDraftResponseSchema } from '../draft-response.contract'

// Streamed frames for `/generate-draft`. Progress ticks carry the current
// stage label + percentage; the terminal `result` frame carries the assembled
// draft. Errors propagate as a thrown ORPCError (no error frame); oRPC's native
// keep-alive pings replace the former NDJSON heartbeat.
export const draftStreamEventSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('progress'), stage: z.string(), pct: z.number() }),
  z.object({ type: z.literal('result'), data: generateDraftResponseSchema }),
])
export type DraftStreamEvent = z.infer<typeof draftStreamEventSchema>

export const scribeGenerateDraft = oc
  .route({ method: 'POST', path: '/v2/scribe/sessions/{encounterId}/generate-draft' })
  .input(
    z.object({
      encounterId: z.string(),
      sessionId: z.string().min(1),
      transcriptOverride: z.string().optional(),
      transcriptDocumentReferenceId: z.string().optional(),
      // PD-1516 — provider AI-Dictate speech as the transcript source (no
      // scribe session; the caller synthesizes `dictate-<encounterId>`).
      dictation: z.string().min(1).max(20_000).optional(),
      // PD-1516 — re-dictation merges, never overwrites:
      // the note as it stands, so the model updates it with the new dictation
      // and preserves provider content. Only meaningful with `dictation`.
      existingNote: z.string().min(1).max(40_000).optional(),
      doctorObservations: z.string().optional(),
      partial: z.boolean().optional(),
    }),
  )
  .output(eventIterator(draftStreamEventSchema))
